import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintEntityId} from "../utils/uid.utils";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {AddImagePackCommand} from "./addImagePack.command";

export class AddUnitCommand extends CommandBase {
    private name: string;
    // Id minted for the created unit; the caller reads it after executeCommand to
    // scroll/focus the new row, mirroring Ctrl/Cmd-click link navigation.
    newId = '';
    constructor(name: string = 'New Unit') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        const id = mintEntityId('unit', this.name, data.units.map(u => u.id));
        this.newId = id;
        data.units.push({
            id: id,
            active: true,
            price: 5,
            score: 1,
            properties: {
                movementSpeed: 1,
                range: 1,
                health: 10,
                attack: 1,
                defense: 1,
                regeneration: 2
            },
            attributes: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);
        return true;
    }
}